export const enum SupportChatLookupStatus {
    NotFound = 0,
    EmailNotVerified = 1,
    PaidOrderFound = 2,
    OrderFoundNotPaid = 3,
    OrderFoundPendingTransfer = 4,
    EventEnded = 5,
    MultipleOrdersFound = 6,
    SimilarEmailFound = 7
}
